import {Public, ViewList} from '@mui/icons-material'
import {TFunction} from 'i18next'
import React from 'react'

import {PlantViewOption, PlantViewOptions} from '../../consts'
import {Toggle, ToggleConfig} from '../toggle'

export const PLANT_VIEWS_CONFIG: ToggleConfig<PlantViewOption> = [
  {
    type: PlantViewOptions.REGIONAL_STRUCTURE,
    labelKey: 'plantViewToggle.regionalStructure',
    icon: Public,
    dataTestId: 'plants-view-toggle-btn-regionalStructure'
  },
  {
    type: PlantViewOptions.PLANT_LIST,
    labelKey: 'plantViewToggle.plantList',
    icon: ViewList,
    dataTestId: 'plants-view-toggle-btn-plantList'
  }
]

type PlantViewToggleProps = {
  value: PlantViewOption
  onChange: (value: PlantViewOption) => void
  t: TFunction
  fullWidth?: boolean
  isContrastMode?: boolean
}

export const PlantViewToggle: React.FC<PlantViewToggleProps> = (props) => (
  <Toggle<PlantViewOption> config={PLANT_VIEWS_CONFIG} {...props} />
)
